import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ManagePPATimeseriesStore } from 'src/app/pages/ppa-inventory/components/manage-ppa-objects/components/manage-ppa-timeseries/manage-ppa-timeseries.component.store';

@Component({
  selector: 'app-timeseries-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      title="Forward Curve"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSeriesIcon {}

@Component({
  selector: 'app-ppa-inventory-timeseries-icon',
  template: `
  <a (click)="navigateToTimeseries()" class="cursor-pointer">
   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="w-6 h-6" viewBox="0 0 256 256" xml:space="preserve">

<defs>
</defs>
<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
	<path d="M 7.47 88.266 c -1.657 0 -3 -1.343 -3 -3 V 4.929 c 0 -1.657 1.343 -3 3 -3 s 3 1.343 3 3 v 80.337 C 10.47 86.923 9.127 88.266 7.47 88.266 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
	<path d="M 87 83.795 H 3 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 84 c 1.657 0 3 1.343 3 3 S 88.657 83.795 87 83.795 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
	<path d="M 19.108 72.21 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 c 23.483 0 40.697 -25.006 48.302 -46.419 c 0.555 -1.562 2.268 -2.378 3.831 -1.823 c 1.562 0.555 2.378 2.27 1.823 3.831 C 64.805 45.054 45.717 72.21 19.108 72.21 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
	<path d="M 74.712 33.195 c -1.121 0 -2.197 -0.631 -2.711 -1.711 l -3.184 -6.691 l -6.69 3.184 c -1.497 0.712 -3.286 0.076 -3.998 -1.42 s -0.076 -3.286 1.42 -3.998 l 9.399 -4.473 c 0.718 -0.342 1.543 -0.384 2.293 -0.118 c 0.75 0.267 1.363 0.82 1.705 1.538 l 4.473 9.4 c 0.712 1.496 0.076 3.286 -1.42 3.998 C 75.583 33.101 75.144 33.195 74.712 33.195 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
</g>
</svg>
</a>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPAInventoryTimeSeriesIcon {
  @Input() ppaPreviewDetails: any = null;
  constructor(private router: Router, private managePPATimeseriesStore: ManagePPATimeseriesStore) {}
  
  navigateToTimeseries(): void {
    this.managePPATimeseriesStore.setPPAPreviewDetails(this.ppaPreviewDetails);
    const baseRoute = '/ppamanageobject/timeseries';
    localStorage.removeItem('endurDealTabs');
    this.router.navigate([baseRoute], { state: { ppaPreviewDetails: this.ppaPreviewDetails } });
  }
}

@Component({
  selector: 'app-dealterm-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealTermIcon {}

@Component({
  selector: 'app-analyticssandbox-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalyticsSandboxIcon {}

@Component({
  selector: 'app-analyticssandbox-metadata-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalyticsSandboxMetadataIcon {}

@Component({
  selector: 'app-modelcalibration-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModelCalibrationIcon {}

@Component({
  selector: 'app-volatilityreference-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VolatilityReferenceIcon {}

@Component({
  selector: 'app-historicdataset-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistoricDatasetIcon {}

@Component({
  selector: 'app-forwardcurvereference-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForwardCurveReferenceIcon {}

@Component({
  selector: 'app-asset-icon',
  template: `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" width="24" height="24">
  <rect x="36" y="6" width="25" height="25" fill="#000"/>
  <rect x="36" y="66" width="25" height="25" fill="#000"/>
  <rect x="6" y="66" width="25" height="25" fill="#000"/>
  <rect x="66" y="66" width="25" height="25" fill="#000"/>
  <polygon points="15,51 46,51 46,63 51,63 51,51 82,51 82,63 87,63 87,46 84,46 84,47 51,47 51,35 46,35 46,47 13,47 13,46 11,46 11,63 15,63"/>
</svg>

  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPAAssetIcon {}

@Component({
  selector: 'app-ppa-business-partner-icon',
  template: `
  <svg fill="#000000" width="24" height="24" viewBox="-3 0 19 19" xmlns="http://www.w3.org/2000/svg" class="cf-icon-svg"><path d="M12.517 12.834v1.9a1.27 1.27 0 0 1-1.267 1.267h-9.5a1.27 1.27 0 0 1-1.267-1.267v-1.9A3.176 3.176 0 0 1 3.65 9.667h5.7a3.176 3.176 0 0 1 3.167 3.167zM3.264 5.48A3.236 3.236 0 1 1 6.5 8.717a3.236 3.236 0 0 1-3.236-3.236z"/></svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPABusinessPartnerIcon {}

@Component({
  selector: 'app-ppa-market-participant-icon',
  template: `
  <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 width="24" height="24" viewBox="0 0 980 980" xml:space="preserve">
<g>
	<g>
		<path d="M970.001,868.211h-25.659V210.402c0-5.523-4.477-10-10-10H43.662c-5.523,0-10,4.477-10,10v657.809H10
			c-5.523,0-10,4.479-10,10v26.984c0,5.521,4.477,10,10,10h960c5.523,0,10-4.479,10-10v-26.984
			C980.001,872.688,975.523,868.211,970.001,868.211z M121.265,798.182c0,5.521-4.477,10-10,10H70.816c-5.523,0-10-4.479-10-10
			v-40.449c0-5.523,4.477-10,10-10h40.449c5.523,0,10,4.477,10,10V798.182z M121.265,712.543c0,5.523-4.477,10-10,10H70.816
			c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.523,0,10,4.477,10,10V712.543z M121.265,626.906
			c0,5.523-4.477,10-10,10H70.816c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.523,0,10,4.477,10,10V626.906z
			 M121.265,541.271c0,5.521-4.477,10-10,10H70.816c-5.523,0-10-4.479-10-10V500.82c0-5.523,4.477-10,10-10h40.449
			c5.523,0,10,4.477,10,10V541.271z M121.265,455.633c0,5.522-4.477,10-10,10H70.816c-5.523,0-10-4.478-10-10v-40.449
			c0-5.523,4.477-10,10-10h40.449c5.523,0,10,4.477,10,10V455.633z M121.265,369.997c0,5.523-4.477,10-10,10H70.816
			c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.523,0,10,4.477,10,10V369.997z M121.265,284.36
			c0,5.523-4.477,10-10,10H70.816c-5.523,0-10-4.477-10-10v-40.45c0-5.523,4.477-10,10-10h40.449c5.523,0,10,4.477,10,10V284.36z
			 M209.925,798.182c0,5.521-4.477,10-10,10h-40.45c-5.523,0-10-4.479-10-10v-40.449c0-5.523,4.477-10,10-10h40.45
			c5.523,0,10,4.477,10,10V798.182z M209.925,712.543c0,5.523-4.477,10-10,10h-40.45c-5.523,0-10-4.477-10-10v-40.449
			c0-5.523,4.477-10,10-10h40.45c5.523,0,10,4.477,10,10V712.543z M209.925,626.906c0,5.523-4.477,10-10,10h-40.45
			c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.45c5.523,0,10,4.477,10,10V626.906z M209.925,541.271
			c0,5.521-4.477,10-10,10h-40.45c-5.523,0-10-4.479-10-10V500.82c0-5.523,4.477-10,10-10h40.45c5.523,0,10,4.477,10,10V541.271z
			 M209.925,455.633c0,5.522-4.477,10-10,10h-40.45c-5.523,0-10-4.478-10-10v-40.449c0-5.523,4.477-10,10-10h40.45
			c5.523,0,10,4.477,10,10V455.633z M209.925,369.997c0,5.523-4.477,10-10,10h-40.45c-5.523,0-10-4.477-10-10v-40.449
			c0-5.523,4.477-10,10-10h40.45c5.523,0,10,4.477,10,10V369.997z M209.925,284.36c0,5.523-4.477,10-10,10h-40.45
			c-5.523,0-10-4.477-10-10v-40.45c0-5.523,4.477-10,10-10h40.45c5.523,0,10,4.477,10,10V284.36z M298.584,798.182
			c0,5.521-4.477,10-10,10h-40.449c-5.523,0-10-4.479-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.523,0,10,4.477,10,10V798.182z
			 M298.584,712.543c0,5.523-4.477,10-10,10h-40.449c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.449
			c5.523,0,10,4.477,10,10V712.543z M298.584,626.906c0,5.523-4.477,10-10,10h-40.449c-5.523,0-10-4.477-10-10v-40.449
			c0-5.523,4.477-10,10-10h40.449c5.523,0,10,4.477,10,10V626.906z M298.584,541.271c0,5.521-4.477,10-10,10h-40.449
			c-5.523,0-10-4.479-10-10V500.82c0-5.523,4.477-10,10-10h40.449c5.523,0,10,4.477,10,10V541.271z M298.584,455.633
			c0,5.522-4.477,10-10,10h-40.449c-5.523,0-10-4.478-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.523,0,10,4.477,10,10V455.633z
			 M298.584,369.997c0,5.523-4.477,10-10,10h-40.449c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.449
			c5.523,0,10,4.477,10,10V369.997z M298.584,284.36c0,5.523-4.477,10-10,10h-40.449c-5.523,0-10-4.477-10-10v-40.45
			c0-5.523,4.477-10,10-10h40.449c5.523,0,10,4.477,10,10V284.36z M387.243,798.182c0,5.521-4.478,10-10,10h-40.449
			c-5.523,0-10-4.479-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.522,0,10,4.477,10,10V798.182z M387.243,712.543
			c0,5.523-4.478,10-10,10h-40.449c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.522,0,10,4.477,10,10V712.543z
			 M387.243,626.906c0,5.523-4.478,10-10,10h-40.449c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.449
			c5.522,0,10,4.477,10,10V626.906z M387.243,541.271c0,5.521-4.478,10-10,10h-40.449c-5.523,0-10-4.479-10-10V500.82
			c0-5.523,4.477-10,10-10h40.449c5.522,0,10,4.477,10,10V541.271z M387.243,455.633c0,5.522-4.478,10-10,10h-40.449
			c-5.523,0-10-4.478-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.522,0,10,4.477,10,10V455.633z M387.243,369.997
			c0,5.523-4.478,10-10,10h-40.449c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.522,0,10,4.477,10,10V369.997z
			 M387.243,284.36c0,5.523-4.478,10-10,10h-40.449c-5.523,0-10-4.477-10-10v-40.45c0-5.523,4.477-10,10-10h40.449
			c5.522,0,10,4.477,10,10V284.36z M530.309,849.57c0,5.523-4.477,10-10,10h-60.603c-5.523,0-10-4.477-10-10v-90.838
			c0-5.523,4.477-10,10-10h60.603c5.523,0,10,4.477,10,10V849.57z M564.562,712.543c0,5.523-4.477,10-10,10H425.453
			c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h129.108c5.523,0,10,4.477,10,10V712.543z M564.562,626.906
			c0,5.523-4.477,10-10,10H425.453c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h129.108c5.523,0,10,4.477,10,10V626.906
			z M564.562,541.271c0,5.521-4.477,10-10,10H425.453c-5.523,0-10-4.479-10-10V500.82c0-5.523,4.477-10,10-10h129.108
			c5.523,0,10,4.477,10,10V541.271z M564.562,455.633c0,5.522-4.477,10-10,10H425.453c-5.523,0-10-4.478-10-10v-40.449
			c0-5.523,4.477-10,10-10h129.108c5.523,0,10,4.477,10,10V455.633z M564.562,369.997c0,5.523-4.477,10-10,10H425.453
			c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h129.108c5.523,0,10,4.477,10,10V369.997z M564.562,284.36
			c0,5.523-4.477,10-10,10H425.453c-5.523,0-10-4.477-10-10v-40.45c0-5.523,4.477-10,10-10h129.108c5.523,0,10,4.477,10,10V284.36z
			 M653.221,798.182c0,5.521-4.477,10-10,10h-40.449c-5.522,0-10-4.479-10-10v-40.449c0-5.523,4.478-10,10-10h40.449
			c5.523,0,10,4.477,10,10V798.182z M653.221,712.543c0,5.523-4.477,10-10,10h-40.449c-5.522,0-10-4.477-10-10v-40.449
			c0-5.523,4.478-10,10-10h40.449c5.523,0,10,4.477,10,10V712.543z M653.221,626.906c0,5.523-4.477,10-10,10h-40.449
			c-5.522,0-10-4.477-10-10v-40.449c0-5.523,4.478-10,10-10h40.449c5.523,0,10,4.477,10,10V626.906z M653.221,541.271
			c0,5.521-4.477,10-10,10h-40.449c-5.522,0-10-4.479-10-10V500.82c0-5.523,4.478-10,10-10h40.449c5.523,0,10,4.477,10,10V541.271z
			 M653.221,455.633c0,5.522-4.477,10-10,10h-40.449c-5.522,0-10-4.478-10-10v-40.449c0-5.523,4.478-10,10-10h40.449
			c5.523,0,10,4.477,10,10V455.633z M653.221,369.997c0,5.523-4.477,10-10,10h-40.449c-5.522,0-10-4.477-10-10v-40.449
			c0-5.523,4.478-10,10-10h40.449c5.523,0,10,4.477,10,10V369.997z M653.221,284.36c0,5.523-4.477,10-10,10h-40.449
			c-5.522,0-10-4.477-10-10v-40.45c0-5.523,4.478-10,10-10h40.449c5.523,0,10,4.477,10,10V284.36z M741.88,798.182
			c0,5.521-4.477,10-10,10h-40.449c-5.522,0-10-4.479-10-10v-40.449c0-5.523,4.478-10,10-10h40.449c5.523,0,10,4.477,10,10V798.182z
			 M741.88,712.543c0,5.523-4.477,10-10,10h-40.449c-5.522,0-10-4.477-10-10v-40.449c0-5.523,4.478-10,10-10h40.449
			c5.523,0,10,4.477,10,10V712.543z M741.88,626.906c0,5.523-4.477,10-10,10h-40.449c-5.522,0-10-4.477-10-10v-40.449
			c0-5.523,4.478-10,10-10h40.449c5.523,0,10,4.477,10,10V626.906z M741.88,541.271c0,5.521-4.477,10-10,10h-40.449
			c-5.522,0-10-4.479-10-10V500.82c0-5.523,4.478-10,10-10h40.449c5.523,0,10,4.477,10,10V541.271z M741.88,455.633
			c0,5.522-4.477,10-10,10h-40.449c-5.522,0-10-4.478-10-10v-40.449c0-5.523,4.478-10,10-10h40.449c5.523,0,10,4.477,10,10V455.633z
			 M741.88,369.997c0,5.523-4.477,10-10,10h-40.449c-5.522,0-10-4.477-10-10v-40.449c0-5.523,4.478-10,10-10h40.449
			c5.523,0,10,4.477,10,10V369.997z M741.88,284.36c0,5.523-4.477,10-10,10h-40.449c-5.522,0-10-4.477-10-10v-40.45
			c0-5.523,4.478-10,10-10h40.449c5.523,0,10,4.477,10,10V284.36z M830.54,798.182c0,5.521-4.478,10-10,10h-40.449
			c-5.522,0-10-4.479-10-10v-40.449c0-5.523,4.478-10,10-10h40.449c5.522,0,10,4.477,10,10V798.182z M830.54,712.543
			c0,5.523-4.478,10-10,10h-40.449c-5.522,0-10-4.477-10-10v-40.449c0-5.523,4.478-10,10-10h40.449c5.522,0,10,4.477,10,10V712.543z
			 M830.54,626.906c0,5.523-4.478,10-10,10h-40.449c-5.522,0-10-4.477-10-10v-40.449c0-5.523,4.478-10,10-10h40.449
			c5.522,0,10,4.477,10,10V626.906z M830.54,541.271c0,5.521-4.478,10-10,10h-40.449c-5.522,0-10-4.479-10-10V500.82
			c0-5.523,4.478-10,10-10h40.449c5.522,0,10,4.477,10,10V541.271z M830.54,455.633c0,5.522-4.478,10-10,10h-40.449
			c-5.522,0-10-4.478-10-10v-40.449c0-5.523,4.478-10,10-10h40.449c5.522,0,10,4.477,10,10V455.633z M830.54,369.997
			c0,5.523-4.478,10-10,10h-40.449c-5.522,0-10-4.477-10-10v-40.449c0-5.523,4.478-10,10-10h40.449c5.522,0,10,4.477,10,10V369.997z
			 M830.54,284.36c0,5.523-4.478,10-10,10h-40.449c-5.522,0-10-4.477-10-10v-40.45c0-5.523,4.478-10,10-10h40.449
			c5.522,0,10,4.477,10,10V284.36z M919.199,798.182c0,5.521-4.478,10-10,10H868.75c-5.523,0-10-4.479-10-10v-40.449
			c0-5.523,4.477-10,10-10h40.449c5.522,0,10,4.477,10,10V798.182z M919.199,712.543c0,5.523-4.478,10-10,10H868.75
			c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.522,0,10,4.477,10,10V712.543z M919.199,626.906
			c0,5.523-4.478,10-10,10H868.75c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.522,0,10,4.477,10,10V626.906z
			 M919.199,541.271c0,5.521-4.478,10-10,10H868.75c-5.523,0-10-4.479-10-10V500.82c0-5.523,4.477-10,10-10h40.449
			c5.522,0,10,4.477,10,10V541.271z M919.199,455.633c0,5.522-4.478,10-10,10H868.75c-5.523,0-10-4.478-10-10v-40.449
			c0-5.523,4.477-10,10-10h40.449c5.522,0,10,4.477,10,10V455.633z M919.199,369.997c0,5.523-4.478,10-10,10H868.75
			c-5.523,0-10-4.477-10-10v-40.449c0-5.523,4.477-10,10-10h40.449c5.522,0,10,4.477,10,10V369.997z M919.199,284.36
			c0,5.523-4.478,10-10,10H868.75c-5.523,0-10-4.477-10-10v-40.45c0-5.523,4.477-10,10-10h40.449c5.522,0,10,4.477,10,10V284.36z"/>
		<path d="M19.143,179.663h939.719c4.286,0,6.585-5.04,3.775-8.277l-38.512-44.374c-1.861-2.745-4.961-4.389-8.277-4.389h-65.233
			c-5.523,0-10-4.477-10-10V74.805c0-5.523-4.478-10-10-10h-32.39c-5.522,0-10,4.477-10,10v37.818c0,5.523-4.477,10-10,10H201.79
			c-5.523,0-10-4.477-10-10V74.805c0-5.523-4.477-10-10-10H149.4c-5.523,0-10,4.477-10,10v37.818c0,5.523-4.477,10-10,10H62.156
			c-3.316,0-6.416,1.645-8.277,4.389l-38.512,44.374C12.557,174.623,14.856,179.663,19.143,179.663z"/>
	</g>
</g>
</svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPAMarketParticipantIcon {}

@Component({
  selector: 'app-ppa-deal-group-icon',
  template: `
<svg fill="#000000" width="20" height="20" stroke-width="1.5" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 491.494 491.494" xml:space="preserve">
<g>
	<g>
		<path d="M476.419,53.917l-38.855-38.86c-20.06-20.05-52.705-20.06-72.775,0l-126.295,126.3c-9.72,9.71-15.07,22.64-15.07,36.38
			c0,13.75,5.35,26.67,15.07,36.39l14.48-14.48c-5.85-5.85-9.07-13.63-9.07-21.91c0-8.27,3.22-16.05,9.07-21.9l126.295-126.3
			c12.08-12.08,31.735-12.08,43.815,0l38.855,38.86c5.85,5.85,9.075,13.63,9.075,21.91c0,8.27-3.22,16.05-9.075,21.9l-126.29,126.3
			c-11.71,11.7-32.115,11.7-43.815,0l-14.48,14.48c9.715,9.72,22.64,15.08,36.385,15.08s26.67-5.36,36.39-15.08l126.29-126.3
			c9.72-9.71,15.075-22.63,15.075-36.38S486.139,63.638,476.419,53.917z"/>
	</g>
</g>
<g>
	<g>
		<path d="M252.974,277.368l-14.48,14.48c5.85,5.85,9.07,13.63,9.07,21.91c0,8.27-3.22,16.05-9.07,21.9l-126.295,126.3
			c-12.08,12.08-31.735,12.08-43.815,0l-38.855-38.86c-12.08-12.08-12.08-31.74,0-43.82l126.29-126.29
			c11.71-11.7,32.115-11.7,43.815,0l14.48-14.48c-9.715-9.72-22.64-15.08-36.385-15.08s-26.67,5.36-36.39,15.08l-126.29,126.29
			c-20.065,20.07-20.065,52.71,0,72.78l38.855,38.86c10.035,10.03,23.21,15.04,36.39,15.04c13.175,0,26.355-5.01,36.385-15.04
			l126.295-126.3c9.72-9.71,15.07-22.64,15.07-36.38C268.044,300.008,262.694,287.088,252.974,277.368z"/>
	</g>
</g>
<g>
	<g>
		
			<rect x="149.549" y="235.505" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -101.7958 245.7455)" width="192.358" height="20.48"/>
	</g>
</g>
</svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPADealGroupIcon {}

@Component({
  selector: 'app-ppa-add-icon',
  template: `
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPAAddIcon {}

@Component({
  selector: 'app-ppa-contract-icon',
  template: `
  <svg fill="#000000" width="24" height="24" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.783 237.783" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 237.783 237.783">
  <g>
    <path d="m42.735,50.071h96.959c3.313,0 6,2.687 6,6s-2.687,6-6,6h-96.959c-3.313,0-6-2.687-6-6s2.686-6 6-6zm0,25.934h96.959c3.313,0 6,2.687 6,6s-2.687,6-6,6h-96.959c-3.313,0-6-2.687-6-6s2.686-6 6-6zm0,25.935h96.959c3.313,0 6,2.687 6,6s-2.687,6-6,6h-96.959c-3.313,0-6-2.687-6-6s2.686-6 6-6zm0,25.935h96.959c3.313,0 6,2.687 6,6s-2.687,6-6,6h-96.959c-3.313,0-6-2.687-6-6s2.686-6 6-6z"/>
    <path d="m42.735,62.071h96.959c3.313,0 6-2.687 6-6s-2.687-6-6-6h-96.959c-3.313,0-6,2.687-6,6s2.686,6 6,6z"/>
    <path d="m42.735,88.005h96.959c3.313,0 6-2.687 6-6s-2.687-6-6-6h-96.959c-3.313,0-6,2.687-6,6s2.686,6 6,6z"/>
    <path d="m42.735,113.94h96.959c3.313,0 6-2.687 6-6s-2.687-6-6-6h-96.959c-3.313,0-6,2.687-6,6s2.686,6 6,6z"/>
    <path d="m42.735,139.875h96.959c3.313,0 6-2.687 6-6s-2.687-6-6-6h-96.959c-3.313,0-6,2.687-6,6s2.686,6 6,6z"/>
    <path d="m237.783,98.361c0-1.591-0.632-3.117-1.757-4.243l-16.356-16.355c-1.125-1.125-2.651-1.757-4.243-1.757s-3.117,0.632-4.243,1.757l-28.756,28.756v-88.117c0-3.313-2.686-6-6-6h-170.428c-3.314,0-6,2.687-6,6v200.979c0,3.313 2.686,6 6,6h170.429c3.314,0 6-2.687 6-6v-63.18l53.597-53.597c1.125-1.125 1.757-2.651 1.757-4.243zm-225.783,115.02v-188.979h158.429v94.117l-35.291,35.291h-92.403c-3.313,0-6,2.687-6,6s2.687,6 6,6h80.403l-1.033,1.033c-0.777,0.777-1.326,1.753-1.586,2.821l-4.157,17.05h-25.148c-3.313,0-6,2.687-6,6s2.687,6 6,6c0,0 29.714,0 29.86,0 0.473,0 0.95-0.056 1.421-0.171l21.629-5.273c1.068-0.26 2.044-0.809 2.821-1.586l23.482-23.482v45.181h-158.427zm127.649-31.374l-10.408,2.538 2.538-10.408 83.648-83.648 7.871,7.871-83.649,83.647z"/>
  </g>
</svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPAContractIcon {}

@Component({
  selector: 'app-tab-nav-icon',
  template: `
<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 64 64">
<path d="M 40 10 C 38.896 10 38 10.896 38 12 C 38 13.104 38.896 14 40 14 L 47.171875 14 L 30.585938 30.585938 C 29.804938 31.366938 29.804938 32.633063 30.585938 33.414062 C 30.976938 33.805063 31.488 34 32 34 C 32.512 34 33.023063 33.805062 33.414062 33.414062 L 50 16.828125 L 50 24 C 50 25.104 50.896 26 52 26 C 53.104 26 54 25.104 54 24 L 54 12 C 54 10.896 53.104 10 52 10 L 40 10 z M 18 12 C 14.691 12 12 14.691 12 18 L 12 46 C 12 49.309 14.691 52 18 52 L 46 52 C 49.309 52 52 49.309 52 46 L 52 34 C 52 32.896 51.104 32 50 32 C 48.896 32 48 32.896 48 34 L 48 46 C 48 47.103 47.103 48 46 48 L 18 48 C 16.897 48 16 47.103 16 46 L 16 18 C 16 16.897 16.897 16 18 16 L 30 16 C 31.104 16 32 15.104 32 14 C 32 12.896 31.104 12 30 12 L 18 12 z"></path>
</svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabNavLinkIcon {}

@Component({
  selector: 'app-default-icon',
  template: `
<svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.493 0.015 C 7.442 0.021,7.268 0.039,7.107 0.055 C 5.234 0.242,3.347 1.208,2.071 2.634 C 0.660 4.211,-0.057 6.168,0.009 8.253 C 0.124 11.854,2.599 14.903,6.110 15.771 C 8.169 16.280,10.433 15.917,12.227 14.791 C 14.017 13.666,15.270 11.933,15.771 9.887 C 15.943 9.186,15.983 8.829,15.983 8.000 C 15.983 7.171,15.943 6.814,15.771 6.113 C 14.979 2.878,12.315 0.498,9.000 0.064 C 8.716 0.027,7.683 -0.006,7.493 0.015 M8.853 1.563 C 9.967 1.707,11.010 2.136,11.944 2.834 C 12.273 3.080,12.920 3.727,13.166 4.056 C 13.727 4.807,14.142 5.690,14.330 6.535 C 14.544 7.500,14.544 8.500,14.330 9.465 C 13.916 11.326,12.605 12.978,10.867 13.828 C 10.239 14.135,9.591 14.336,8.880 14.444 C 8.456 14.509,7.544 14.509,7.120 14.444 C 5.172 14.148,3.528 13.085,2.493 11.451 C 2.279 11.114,1.999 10.526,1.859 10.119 C 1.618 9.422,1.514 8.781,1.514 8.000 C 1.514 6.961,1.715 6.075,2.160 5.160 C 2.500 4.462,2.846 3.980,3.413 3.413 C 3.980 2.846,4.462 2.500,5.160 2.160 C 6.313 1.599,7.567 1.397,8.853 1.563 M7.706 4.290 C 7.482 4.363,7.355 4.491,7.293 4.705 C 7.257 4.827,7.253 5.106,7.259 6.816 C 7.267 8.786,7.267 8.787,7.325 8.896 C 7.398 9.033,7.538 9.157,7.671 9.204 C 7.803 9.250,8.197 9.250,8.329 9.204 C 8.462 9.157,8.602 9.033,8.675 8.896 C 8.733 8.787,8.733 8.786,8.741 6.816 C 8.749 4.664,8.749 4.662,8.596 4.481 C 8.472 4.333,8.339 4.284,8.040 4.276 C 7.893 4.272,7.743 4.278,7.706 4.290 M7.786 10.530 C 7.597 10.592,7.410 10.753,7.319 10.932 C 7.249 11.072,7.237 11.325,7.294 11.495 C 7.388 11.780,7.697 12.000,8.000 12.000 C 8.303 12.000,8.612 11.780,8.706 11.495 C 8.763 11.325,8.751 11.072,8.681 10.932 C 8.616 10.804,8.460 10.646,8.333 10.580 C 8.217 10.520,7.904 10.491,7.786 10.530 " stroke="none" fill-rule="evenodd" fill="#000000"></path></svg>

  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPADefaultIcon {}

@Component({
  selector: 'app-ppa-deal-icon',
  template: `
  <svg version="1.1" id="real_x5F_estate_1_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
	 y="0px" width="24" height="24" viewBox="-235 162 128 128" style="enable-background:new -235 162 128 128;" xml:space="preserve">
<style type="text/css">
	.st0{display:none;}
	.st1{display:inline;}
	.st2{fill:#0F0F0F;}
	.st3{display:inline;fill:#0F0F0F;}
</style>
<g id="sold_1_" class="st0">
	<g id="icon" class="st1">
		<g>
			<path class="st2" d="M-211.7,248.1h9.3v-9.3h-9.3V248.1z M-200.1,250.4h-2.3l0,0h-9.3v16.3h20.9v-16.3H-200.1L-200.1,250.4z
				 M-179.1,185.3l-55.9,27.9h104.7L-179.1,185.3z M-179.1,206.2c-2.6,0-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7c2.6,0,4.7,2.1,4.7,4.7
				S-176.6,206.2-179.1,206.2z M-146.6,189.9h-11.6v6.5l11.6,5.1V189.9z M-172.2,243.5c0-10.3,6.4-18.6,16.3-18.6h14v-9.3h-81.5
				v51.2h9.3v-42h25.6v41.9h46.6V262c-7.8,0-14,0-14,0C-165.8,262.1-172.2,253.7-172.2,243.5z M-202.4,227.1h-9.3v9.3h9.3V227.1z
				 M-200.1,236.5h9.3v-9.3h-9.3V236.5z M-200.1,248.1h9.3v-9.3h-9.3V248.1z M-135.9,238.8h26.6c1.3,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3
				h-28.5C-137,235.6-136.4,237.1-135.9,238.8z M-109.3,248.1h-26.6c-0.4,1.7-1.1,3.2-1.9,4.7h28.5c1.3,0,2.3-1,2.3-2.3
				C-107,249.2-108,248.1-109.3,248.1z M-153.5,227.2c-9,0-16.3,7.3-16.3,16.3s7.3,16.3,16.3,16.3s16.3-7.3,16.3-16.3
				C-137.3,234.5-144.5,227.2-153.5,227.2z M-148,249.8c-0.4,0.7-0.9,1.4-1.5,1.9s-1.4,0.9-2.2,1.1c-0.1,0-0.2,0-0.3,0.1v2.5h-2.3
				v-2.2h-0.1c-0.7,0-1.3-0.1-1.8-0.2c-0.6-0.1-1-0.2-1.5-0.4c-0.4-0.2-0.8-0.3-1.1-0.5s-0.5-0.3-0.6-0.4c-0.1-0.1-0.2-0.3-0.3-0.5
				c-0.1-0.2-0.1-0.6-0.1-1c0-0.3,0-0.6,0-0.8c0-0.2,0-0.4,0.1-0.5c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.1s0.3,0.1,0.6,0.2
				c0.2,0.2,0.6,0.3,1,0.5s0.8,0.4,1.4,0.5c0.5,0.2,1.2,0.2,1.9,0.2c0.5,0,0.9-0.1,1.2-0.2c0.4-0.1,0.7-0.3,0.9-0.5
				c0.3-0.2,0.5-0.5,0.6-0.8s0.2-0.6,0.2-1s-0.1-0.8-0.4-1.1c-0.2-0.3-0.5-0.6-0.9-0.8c-0.4-0.2-0.8-0.5-1.3-0.7
				c-0.5-0.2-1-0.4-1.5-0.7c-0.5-0.2-1-0.5-1.5-0.8c-0.5-0.3-0.9-0.6-1.3-1.1c-0.4-0.4-0.7-0.9-0.9-1.5c-0.2-0.6-0.3-1.2-0.3-2
				c0-0.9,0.2-1.7,0.5-2.4c0.3-0.7,0.8-1.2,1.4-1.7c0.6-0.4,1.2-0.8,2-1c0.4-0.1,0.8-0.2,1.2-0.3v-2.4h2.4v2.4c0.1,0,0.2,0,0.3,0
				c0.4,0.1,0.9,0.2,1.3,0.3c0.4,0.1,0.7,0.2,1,0.4s0.5,0.3,0.6,0.4c0.1,0.1,0.2,0.2,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3s0,0.3,0,0.4
				c0,0.2,0,0.4,0,0.6c0,0.3,0,0.5,0,0.7c0,0.2,0,0.4-0.1,0.5c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.1s-0.3-0.1-0.5-0.2
				s-0.5-0.3-0.9-0.4c-0.3-0.2-0.7-0.3-1.2-0.4c-0.4-0.1-0.9-0.2-1.5-0.2c-0.4,0-0.8,0.1-1.1,0.2s-0.6,0.2-0.8,0.4
				c-0.2,0.2-0.4,0.4-0.5,0.6s-0.2,0.5-0.2,0.8c0,0.4,0.1,0.8,0.3,1.1c0.2,0.3,0.5,0.6,0.9,0.8c0.4,0.2,0.8,0.5,1.3,0.7
				c0.5,0.2,1,0.4,1.5,0.7c0.5,0.2,1,0.5,1.5,0.8c0.5,0.3,0.9,0.6,1.3,1.1c0.4,0.4,0.7,0.9,0.9,1.5s0.4,1.2,0.4,2
				C-147.4,248.2-147.6,249.1-148,249.8z M-109.3,255.1h-30.1c-1.5,1.9-3.4,3.5-5.5,4.7h35.6c1.3,0,2.3-1,2.3-2.3
				C-107,256.1-108,255.1-109.3,255.1z M-109.3,241.1h-26.2c0.1,0.8,0.2,1.5,0.2,2.3c0,0.8-0.1,1.6-0.2,2.3h26.1
				c1.3,0,2.3-1,2.3-2.3C-107,242.2-108,241.1-109.3,241.1z"/>
		</g>
	</g>
</g>
<g id="Map_1_" class="st0">
	<g id="icon_1_" class="st1">
		<g>
			<path class="st2" d="M-229.7,191.3h34.7v16h5.3v-16h5.3V186H-235v10.7h5.3V191.3z M-163,186v5.3h50.7v13.3h-40v5.4h8v13.3h-8v5.3
				h40v32H-123v5.3h16V186H-163z M-139,223.3h-2.7V210h2.7V223.3z M-133.7,223.3h-2.7V210h2.7V223.3z M-128.3,223.3h-2.7V210h2.7
				V223.3z M-123,223.3h-2.7V210h2.7V223.3z M-117.7,223.3h-2.7V210h2.7V223.3z M-112.3,223.3h-2.7V210h2.7V223.3z M-229.7,231.3h40
				v-8h-5.3v2.7h-34.7v-8h-5.3v48h24v-5.3h-18.7V231.3z M-168.3,236.7h-5.3v24h-24v5.3h53.3v-5.3h-24V236.7z"/>
		</g>
	</g>
</g>
<g id="open_1_" class="st0">
	<g id="icon_2_" class="st1">
		<path class="st2" d="M-202.5,235.2c-2.5,0-2.8,2.4-2.8,9.6c0,7.3,0.4,9.6,2.8,9.6c2.5,0,2.9-2.3,2.9-9.6
			C-199.6,237.5-200,235.2-202.5,235.2z M-202.5,235.2c-2.5,0-2.8,2.4-2.8,9.6c0,7.3,0.4,9.6,2.8,9.6c2.5,0,2.9-2.3,2.9-9.6
			C-199.6,237.5-200,235.2-202.5,235.2z M-202.5,235.2c-2.5,0-2.8,2.4-2.8,9.6c0,7.3,0.4,9.6,2.8,9.6c2.5,0,2.9-2.3,2.9-9.6
			C-199.6,237.5-200,235.2-202.5,235.2z M-183.2,236.1h-1.6v6.9h1.8c2.5,0,3.1-1.6,3.1-3.3C-180,237.7-180.6,236.1-183.2,236.1z
			 M-183.2,236.1h-1.6v6.9h1.8c2.5,0,3.1-1.6,3.1-3.3C-180,237.7-180.6,236.1-183.2,236.1z M-202.5,235.2c-2.5,0-2.8,2.4-2.8,9.6
			c0,7.3,0.4,9.6,2.8,9.6c2.5,0,2.9-2.3,2.9-9.6C-199.6,237.5-200,235.2-202.5,235.2z M-117.1,210.8h-107.8c-6.1,0-10.1,4-10.1,10.1
			v47.2c0,6.2,4,10.1,10.1,10.1h107.8c6.1,0,10.1-3.9,10.1-10.1v-47.2C-107,214.8-111,210.8-117.1,210.8z M-202.5,258.5
			c-8.2,0-9.3-5.3-9.3-13.7c0-8.4,1.1-13.7,9.3-13.7c8.8,0,9.3,6.4,9.3,13.7S-193.6,258.5-202.5,258.5z M-182,247.7h-2.7V258h-6.3
			v-26.5h9.6c6.6,0,7.8,4.7,7.8,8.1C-173.5,244.3-175.8,247.7-182,247.7z M-155,258h-15.8v-26.5h15.3v5.1h-9.1v5.3h8.6v5.1h-8.5v6
			h9.5V258z M-132.4,258h-7l-5.5-18.2h-0.1V258h-5.6v-26.5h7.2l5.1,17.2h0.1v-17.2h5.8V258z M-183.2,236.1h-1.6v6.9h1.8
			c2.5,0,3.1-1.6,3.1-3.3C-180,237.7-180.6,236.1-183.2,236.1z M-202.5,235.2c-2.5,0-2.8,2.4-2.8,9.6c0,7.3,0.4,9.6,2.8,9.6
			c2.5,0,2.9-2.3,2.9-9.6C-199.6,237.5-200,235.2-202.5,235.2z M-202.5,235.2c-2.5,0-2.8,2.4-2.8,9.6c0,7.3,0.4,9.6,2.8,9.6
			c2.5,0,2.9-2.3,2.9-9.6C-199.6,237.5-200,235.2-202.5,235.2z M-183.2,236.1h-1.6v6.9h1.8c2.5,0,3.1-1.6,3.1-3.3
			C-180,237.7-180.6,236.1-183.2,236.1z M-183.2,236.1h-1.6v6.9h1.8c2.5,0,3.1-1.6,3.1-3.3C-180,237.7-180.6,236.1-183.2,236.1z
			 M-202.5,235.2c-2.5,0-2.8,2.4-2.8,9.6c0,7.3,0.4,9.6,2.8,9.6c2.5,0,2.9-2.3,2.9-9.6C-199.6,237.5-200,235.2-202.5,235.2z
			 M-161.2,186.2c0.2-0.7,0.3-1.5,0.3-2.3c0-5.6-4.5-10.1-10.1-10.1c-5.6,0-10.1,4.5-10.1,10.1c0,0.8,0.1,1.5,0.3,2.3l-37.4,21.3
			h10.1l30-16.4c1.9,1.8,4.3,2.9,7.1,2.9s5.2-1.1,7.1-2.9l30,16.4h10.1L-161.2,186.2z"/>
	</g>
</g>
<g id="car_x5F_garage_1_" class="st0">
	<g id="icon_3_" class="st1">
		<g>
			<path class="st2" d="M-169.3,172.9l-65.7,34.4v12.5l65.7-34.3l62.3,34.3v-12.5L-169.3,172.9z M-136.7,238.5h1.6l-9.4-25h-50
				l-9.4,25h1.6c-6,0-10.9,4.9-10.9,10.9s4.9,17.2,10.9,17.2h1.6v6.2c0,3.4,2.8,6.2,6.2,6.2c0,0,6.2-0.7,6.2-6.2v-6.2h37.5v6.2
				c0,5.5,6.2,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2v-6.2h1.6c6,0,10.9-11.1,10.9-17.2C-125.7,243.4-130.6,238.5-136.7,238.5z
				 M-199.1,254.1c-2.6,0-4.7-2.1-4.7-4.7c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2.1,4.7,4.7C-194.4,252-196.5,254.1-199.1,254.1z
				 M-155.4,254.1h-25c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6h25c0.9,0,1.6,0.7,1.6,1.6S-154.5,254.1-155.4,254.1z M-155.4,247.9
				h-25c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6h25c0.9,0,1.6,0.7,1.6,1.6C-153.8,247.2-154.5,247.9-155.4,247.9z M-194.4,238.5
				l6.2-15.6h37.5l6.2,15.6H-194.4z M-139.8,254.1c-2.6,0-4.7-2.1-4.7-4.7c0-2.6,2.1-4.7,4.7-4.7s4.7,2.1,4.7,4.7
				C-135.1,252-137.2,254.1-139.8,254.1z"/>
		</g>
	</g>
</g>
<g id="hands_1_">
	<g id="icon_4_">
		<g>
			<path class="st2" d="M-194.9,243.7c-1.1-1.2-3-1.2-4.2-0.1l-4.3,4.1c-1.2,1.1-1.2,3-0.1,4.2s3,1.2,4.2,0.1l4.3-4.1
				C-193.8,246.8-193.8,244.9-194.9,243.7z M-186.6,248.2c-1.1-1.2-3-1.2-4.2-0.1l-6.5,6.1c-1.2,1.1-1.2,3-0.1,4.2
				c1.1,1.2,3,1.2,4.2,0.1l6.5-6.1C-185.6,251.2-185.5,249.4-186.6,248.2z M-174.4,261.1c-1.1-1.2-3-1.2-4.2-0.1l-4.3,4.1
				c-1.2,1.1-1.2,3-0.1,4.2c1.1,1.2,3,1.2,4.2,0.1l4.3-4.1C-173.4,264.1-173.3,262.3-174.4,261.1z M-204.3,184l-30.7,34.9l13.9,11.9
				l30.7-34.9L-204.3,184z M-221.4,221.9c-2.4,0.2-4.6-1.6-4.8-4.1c-0.2-2.4,1.6-4.6,4.1-4.8c2.4-0.2,4.6,1.6,4.8,4.1
				C-217.1,219.5-218.9,221.7-221.4,221.9z M-173.6,224.1c0,0-13.9,2.2-22.4-1.2c-6.2-2.6,1.9-13.7,13.8-13c-2.4-1.9-11.1-7-11.1-7
				l-21.2,24.8l13.7,10.4l1.4,4.3c0,0,3.2-2,5.8,0.4c2.6,2.3,0.8,5.2-0.1,6.4c1.9-1.9,5.8-4.7,8.1-2.8c5.1,4.2-4.3,10.1-3.6,10.8
				c0.9,0.9,6.1-8.7,10.4-3c1.5,2-0.8,5.4-2.4,7.3c2-2,4.7-4.3,7.8-1.3c2.5,2.5-1.7,7.4-1.7,7.4s4.8,1.7,7-0.5
				c2.7-2.8-9-13.5-9-13.5l1.2-0.4c0,0,11.3,15.9,15.9,11.3c4.1-4.1-11.4-15.4-11.4-15.4l1.4-1.4c0,0,14.7,15.5,18.4,10.2
				c3-4.2-13-14.8-13-14.8l1.5-1.3c0,0,13.8,11.1,16.6,6.8C-142.2,242-173.6,224.1-173.6,224.1z M-167.3,213.5c0,0-20.1-3.8-27,4.2
				c-6.5,7.5,24.7,3.5,23.4,4.5c3.1,3.4,25.2,19.1,25.2,19.1l18.1-12.8l-18.4-26.8L-167.3,213.5z M-194.7,250.3c0,0,0.5-0.4,1.1-1.1
				C-194.3,249.9-194.7,250.3-194.7,250.3z M-133.5,184.6l-14.4,10.1l26.5,37.2l14.4-10.1L-133.5,184.6z M-120.3,222.9
				c-2.4,0.2-4.6-1.6-4.8-4.1c-0.2-2.4,1.6-4.6,4.1-4.8c2.4-0.2,4.6,1.6,4.8,4.1S-117.9,222.7-120.3,222.9z M-181.2,261.5
				c-0.8,0.8-1.3,1.5-1.3,1.5S-181.9,262.4-181.2,261.5z M-180.5,254.6c-1.1-1.2-3-1.2-4.2-0.1l-6.5,6.1c-1.2,1.1-1.2,3-0.1,4.2
				c1.1,1.2,3,1.2,4.2,0.1l6.5-6.1C-179.5,257.7-179.4,255.8-180.5,254.6z"/>
		</g>
	</g>
</g>
<g id="agreement_1_" class="st0">
	<g id="icon_5_" class="st1">
		<g>
			<path class="st2" d="M-154.2,162h-64v128h94.3v-94.3h-30.3V162z M-174.4,175.5l16.8,13.5h-6.7v13.5h-6.7v-6.7h-6.7v6.7h-6.7
				v-13.6h-6.7L-174.4,175.5z M-204.7,226h67.4v3.4h-67.4V226z M-204.7,236.1h67.4v3.4h-67.4V236.1z M-204.7,246.2h67.4v3.4h-67.4
				V246.2z M-174.4,259.7h-30.3v-3.4h30.3V259.7z M-140.3,282.7c1.8-2.6-3.2-14.1-3.2-14.1L-147,283l-4.3-8.1l-6.3,11.7l3.6-21.6
				l7.2,12.1c-2.9-8.4-0.2-18.5,6.8-12.1C-132.9,271.3-140.3,282.7-140.3,282.7z M-137.3,215.9v3.4h-67.4v-3.4H-137.3z M-150.8,162
				v30.3h26.9L-150.8,162z"/>
		</g>
	</g>
</g>
<g id="door_1_" class="st0">
	<g id="icon_6_" class="st1">
		<g>
			<path class="st2" d="M-222.9,162v3.5h3.5V290h3.4V165.5h90V290h3.5V165.5h3.5V162H-222.9z M-212.5,290h83V168.9h-83V290z
				 M-167.5,182.7h24.2v13.9h-24.2V182.7z M-167.5,203.5h24.2v13.9h-24.2V203.5z M-167.5,224.3h24.2v13.8h-24.2V224.3z M-171,253.1
				h17.7c0,0,0.3,0.5,0.6-0.3c1-2.5,3.4-4.3,6.2-4.3c3.7,0,6.7,3.1,6.7,6.9c0,3.8-3,6.9-6.7,6.9c-2.7,0-5-1.7-6.1-4
				c-0.4-0.9-0.6-0.6-0.6-0.6H-171V253.1z M-198.7,182.7h24.2v13.9h-24.2V182.7z M-198.7,203.5h24.2v13.9h-24.2V203.5z
				 M-198.7,224.3h24.2v13.8h-24.2V224.3z"/>
		</g>
	</g>
</g>
<g id="building_1_" class="st0">
	<g id="icon_7_" class="st1">
		<path class="st2" d="M-146.4,173.5h-13.1l-75.5,36.1V272v6.6h74.5h14.3h39.2V272v-78.8L-146.4,173.5z M-146.4,180.1l32.8,16.4v6.5
			l-32.8-13.1V180.1z M-146.4,199.7l32.8,13.1V226l-32.8-9.8C-146.4,216.2-146.4,199.7-146.4,199.7z M-146.4,226l32.8,9.8v16.4
			l-32.8-9.8C-146.4,242.4-146.4,226-146.4,226z M-159.5,226v16.4l-68.9,16.4V249L-159.5,226z M-228.4,239.1v-9.8l68.9-29.5v16.4
			L-228.4,239.1z M-159.5,180.1v9.8l-68.9,29.5v-6.6L-159.5,180.1z M-160.1,271.9h-68.3v-6.6l68.9-13.1v19.7
			C-159.5,271.9-160.1,271.9-160.1,271.9z M-146.2,271.9h-0.2v-19.6l32.8,9.8v9.8C-113.6,271.9-146.2,271.9-146.2,271.9z"/>
	</g>
</g>
<g id="Wash_x5F_basin_1_" class="st0">
	<g id="icon_8_" class="st1">
		<g>
			<path class="st2" d="M-154.5,211.5v-8.3h-8.3c0-8.5,0-2.8,0-16.5s-4-24.8-14.5-24.8c-5.1,0-9.6,4.5-12.1,11.3
				c-1.5,3.9,6.4,6.1,7.2,3.3c1.1-3.9,2.9-6.5,4.9-6.4c5.6,0.3,6.2,7.4,6.2,16.5s0,8.6,0,16.5h-8.3v8.3h-45.3c0,0,0,3,0,6.2
				c0,12.7,17.7,22,34,27l7.3,16.4v29h28.9v-28.9l8.3-16.5c16.1-5,33-14.3,33-26.8c0-2.7,0-6.2,0-6.2h-41.3V211.5z M-183.5,199.2
				h-8.3c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1,4.1,4.1h8.3c2.3,0,4.1-1.8,4.1-4.1S-181.2,199.2-183.5,199.2z M-150.4,207.4h8.3
				c2.3,0,4.1-1.8,4.1-4.1s-1.8-4.1-4.1-4.1h-8.3c-2.3,0-4.1,1.8-4.1,4.1S-152.7,207.4-150.4,207.4z"/>
		</g>
	</g>
</g>
<g id="table_1_" class="st0">
	<g id="icon_9_" class="st1">
		<g>
			<path class="st2" d="M-211.7,256.5h81.5v-23.2h-81.5V256.5z M-171,239.1c3.2,0,5.8,2.6,5.8,5.8c0,3.2-2.6,5.8-5.8,5.8
				s-5.8-2.6-5.8-5.8C-176.8,241.7-174.2,239.1-171,239.1z M-235,183.8v14.5h5.8v69.8h11.6v-69.7h93.1v69.8h11.6v-69.8h5.8v-14.6
				H-235z M-211.7,227.5h81.5v-23.3h-81.5V227.5z M-171,210c3.2,0,5.8,2.6,5.8,5.8s-2.6,5.8-5.8,5.8s-5.8-2.6-5.8-5.8
				S-174.2,210-171,210z"/>
		</g>
	</g>
</g>
<g id="bed_1_" class="st0">
	<g id="icon_10_" class="st1">
		<g>
			<path class="st2" d="M-235,270.8h12.8l3.2-16h96l3.2,16h12.8v-25.6h-128V270.8z M-215.8,213.2c0-3.5,2.9-6.4,6.4-6.4h25.6
				c3.5,0,6.4,2.9,6.4,6.4v6.4h12.8v-6.4c0-3.5,2.9-6.4,6.4-6.4h25.6c3.5,0,6.4,2.9,6.4,6.4v6.4h9.6V194c0,0-26.5-12.8-53.4-12.8
				c-27.5,0-55.4,12.8-55.4,12.8v25.6h9.6V213.2z M-113.4,222.8h-12.8h-38.4h-12.8h-38.4h-12.8c-3.5,0-6.4,2.9-6.4,6.4V242h128
				v-12.8C-107,225.7-109.9,222.8-113.4,222.8z"/>
		</g>
	</g>
</g>
<g id="search_x5F_home_1_" class="st0">
	<g id="icon_11_" class="st1">
		<g>
			<path class="st2" d="M-162.5,251.4c-4.8-0.9-9.2-2.7-13.1-5.3v18.8h23.2v-13.2C-155.6,252.1-159,252-162.5,251.4z M-179.5,191.2
				l-6.4-3.8l-49.1,25.8v7.8h7.7v43.9h23.3v-31h17.2c-2.1-3.9-3.6-8.2-4.1-12.7C-192.2,209.2-187.5,198.4-179.5,191.2z
				 M-176.2,193.1c-2.8,2.6-13.7,14.6-7.1,35.6c0.6,1.9,1.6,3.6,2.8,5.2h4.9v4.3c9.4,6.2,23.2,7.2,23.2,7.2V221h10.4v-7.7
				L-176.2,193.1z"/>
		</g>
	</g>
	<g id="icon_12_" class="st1">
		<g>
			<path class="st2" d="M-134.7,194.8c-12.1-12.1-31.7-12.1-43.8,0c-12.1,12.1-12.1,31.7,0,43.8c12.1,12.1,31.7,12.1,43.8,0
				C-122.6,226.5-122.6,206.9-134.7,194.8z M-173.1,233.1c-9.1-9.1-9.1-23.8,0-32.9c9.1-9.1,23.8-9.1,32.9,0
				c9.1,9.1,9.1,23.8,0,32.9C-149.3,242.2-164,242.2-173.1,233.1z M-122.7,243.3l-1.8,1.8l-8.4-8.4l-3.7,3.7l8.4,8.4l-1.8,1.8
				l15.7,15.7l7.3-7.3L-122.7,243.3z"/>
		</g>
	</g>
</g>
<g id="Key_1_" class="st0">
	<g id="icon_13_" class="st1">
		<g>
			<path class="st2" d="M-142.4,178.8c-19.5,0-35.4,15.8-35.4,35.4c0,1.3,0.2,4,0.2,4l-50.7,31.4l-6.7,16.9l16.8,6.7l3.4-13.5
				l13.5,6.7l3.4-13.5l13.5,6.7l3.4-13.5l10,3.5c0,0,4-2,9.6-5.6c5.5,3.5,12,5.6,19,5.6c19.5,0,35.4-15.8,35.4-35.4
				C-107,194.7-122.8,178.8-142.4,178.8z M-137.3,222.6c-5.6,0-10.1-4.5-10.1-10.1s4.5-10.1,10.1-10.1s10.1,4.5,10.1,10.1
				C-127.2,218.1-131.7,222.6-137.3,222.6z"/>
		</g>
	</g>
</g>
<g id="table_x5F_chair_1_" class="st0">
	<g id="icon_14_" class="st1">
		<g>
			<path class="st2" d="M-133.8,209.5h-72.3v10.3h8.3v35.1h4.1v-35.1h45.4v35.1h4.1v-35.1h10.3L-133.8,209.5L-133.8,209.5z
				 M-228.8,197.1h-6.2v57.8h6.2v-12.4h19.4l1.3,12.4h4.1v-20.6v-6.2h-24.8V197.1z M-210.3,234.3l0.6,6.2h-19.1v-6.2H-210.3z
				 M-113.2,197.1v31H-138v6.2v20.6h4.1l1.3-12.4h19.4v12.4h6.2v-57.8H-113.2z M-113.2,240.5h-19.2l0.6-6.2h18.5L-113.2,240.5
				L-113.2,240.5z"/>
		</g>
	</g>
</g>
<g id="Lamp_1_" class="st0">
	<path id="icon_42_" class="st3" d="M-164.6,217.5v17.1c2.7,0,3.7,3.2,3.7,5.9v4.9c0,0,14.9,6.8,14.9,19.9
		c0,13.1-10.7,24.7-10.7,24.7h-28c0,0-10.4-11.6-10.7-24.8c0-13.5,14.9-19.9,14.9-19.9v-4.9c0-2.7,0.3-5.9,3-5.9v-17H-203v34.1
		c2.1,0.6,4.3,2,4.3,4.3c0,2.7-5.8,8.5-8.5,8.5s-8.5-5.8-8.5-8.5c0-2.3,2.2-3.7,4.3-4.3v-34.1h-12.9l34.1-55.5h38.4l34.1,55.5
		H-164.6z"/>
</g>
<g id="Sofa_1_" class="st0">
	<g id="icon_16_" class="st1">
		<g>
			<path class="st2" d="M-117.9,208.3c-7.3,0-10.9,8.2-10.9,8.2s-2.7,7.8-2.7,16.3c0,3.1,0.2,6.3,0.5,9.3c-8-2.4-24.3-6.6-38.6-6.6
				c-14.4,0-32.7,4.4-41.4,6.8c0.3-3.1,0.5-6.4,0.5-9.5c0-9.1-2.7-16.3-2.7-16.3s-3.6-8.2-10.9-8.2c-6.3,0-10.9,2.2-10.9,10.9
				s16.3,38.1,16.3,38.1h2.7h2.7h13.6v8.2h10.9v-8.2h38.1v8.2h10.9v-8.2h10.9h2.7h2.7c0,0,16.3-29.4,16.3-38.1
				C-107,210.5-111.6,208.3-117.9,208.3z M-210.5,213.7c1.1,2.5,2.7,12.6,2.7,19.1c0,3.7,0,5,0,5.4c0,0,19.8-5.4,38.1-5.4
				c18.5,0,35.4,5.4,35.4,5.4c0-0.7,0-2.3,0-5.4s1.4-15.8,2.7-19.1c1.9-4.8,13.6-10.9,13.6-10.9c0-3-3-3.9-5.4-5.4
				c0,0-25.1-10.9-46.3-10.9c-21,0-46.3,10.9-46.3,10.9c-2.6,1.4-5.4,2.4-5.4,5.4C-221.4,202.9-211.6,211.2-210.5,213.7z"/>
		</g>
	</g>
</g>
<g id="Sale_1_" class="st0">
	<g id="Base" class="st1">
		<path class="st2" d="M-170.5,221.1h-0.1l-2.2,12.1h4.6L-170.5,221.1z M-170.5,221.1h-0.1l-2.2,12.1h4.6L-170.5,221.1z
			 M-124.3,198.3v6.9h-24.2v-6.9h-31.1v6.9h-24.3v-6.9h-13.8v51.9c0,3.8,3.1,6.9,6.9,6.9h93.4c3.8,0,6.9-3.1,6.9-6.9v-51.9H-124.3z
			 M-192.1,243.8c-4.6,0-8.9-1.4-8.9-7.1V235h6.2v1c0,2,0.6,3.6,2.8,3.6s2.9-1.7,2.9-3.2c0-5.9-11.7-2.6-11.7-12.8
			c0-4.3,2.3-8,8.9-8c6.4,0,8.7,3.3,8.7,7.4v0.6h-6.2c0-1.3-0.1-2.2-0.5-2.8c-0.4-0.7-1-1-1.9-1c-1.6,0-2.6,1-2.6,2.9
			c0,5.7,11.7,2.8,11.7,12.4C-182.8,241.4-186.2,243.8-192.1,243.8z M-166.2,243.3l-1-5.2h-6.5l-0.9,5.2h-6.6l6.9-27.2h8l6.8,27.2
			H-166.2z M-143,243.3h-15.6v-27.2h6.4v22h9.2V243.3z M-125.2,243.3h-16.2v-27.2h15.7v5.2h-9.3v5.4h8.8v5.2h-8.8v6.2h9.8V243.3z
			 M-170.6,221.1l-2.2,12.1h4.6l-2.3-12.1H-170.6z M-170.5,221.1h-0.1l-2.2,12.1h4.6L-170.5,221.1z M-170.5,221.1h-0.1l-2.2,12.1
			h4.6L-170.5,221.1z M-127.8,184.5V181h-17.3v3.5h-38V181h-17.3v3.5h-24.2v-1.7c0-2.9-2.3-5.2-5.2-5.2c-2.9,0-5.2,2.3-5.2,5.2v91.7
			h10.4v-79.6h24.2v6.9h17.3v-6.9h38.1v6.9h17.3v-6.9h20.7v-10.4H-127.8z"/>
	</g>
</g>
<g id="Rent_1_" class="st0">
	<g id="Base_1_" class="st1">
		<path class="st2" d="M-197,220.6h-2v7h2c2.6,0,3.3-1.9,3.3-3.6C-193.7,222-194.5,220.6-197,220.6z M-197,220.6h-2v7h2
			c2.6,0,3.3-1.9,3.3-3.6C-193.7,222-194.5,220.6-197,220.6z M-197,220.6h-2v7h2c2.6,0,3.3-1.9,3.3-3.6
			C-193.7,222-194.5,220.6-197,220.6z M-197,220.6h-2v7h2c2.6,0,3.3-1.9,3.3-3.6C-193.7,222-194.5,220.6-197,220.6z M-124.3,198.3
			v6.9h-24.2v-6.9h-31.1v6.9h-24.3v-6.9h-13.8v51.9c0,3.8,3.1,6.9,6.9,6.9h93.4c3.8,0,6.9-3.1,6.9-6.9v-51.9H-124.3z M-186.3,243.3
			h-6.9c-0.5-0.9-0.7-2.4-0.7-5.5c0-4.7-0.6-5.7-2.7-5.7h-2.4v11.2h-6.4v-27.2h10.7c5.5,0,7.3,3.4,7.3,7.1c0,4-1.6,5.9-4.6,6.6v0.1
			c4,0.6,4.3,3.1,4.4,6.8c0.1,5.4,0.3,5.9,1.2,6.3L-186.3,243.3L-186.3,243.3z M-168.4,243.3h-16.2v-27.2h15.7v5.2h-9.3v5.4h8.8v5.2
			h-8.8v6.2h9.8V243.3z M-145.2,243.3h-7.2l-5.6-18.7h-0.1v18.7h-5.7v-27.2h7.4l5.2,17.7h0.1v-17.7h5.9
			C-145.2,216.1-145.2,243.3-145.2,243.3z M-123.6,221.3h-5.7v22h-6.4v-22h-5.7v-5.2h17.8C-123.6,216.1-123.6,221.3-123.6,221.3z
			 M-197,220.6h-2v7h2c2.6,0,3.3-1.9,3.3-3.6C-193.7,222-194.5,220.6-197,220.6z M-197,220.6h-2v7h2c2.6,0,3.3-1.9,3.3-3.6
			C-193.7,222-194.5,220.6-197,220.6z M-197,220.6h-2v7h2c2.6,0,3.3-1.9,3.3-3.6C-193.7,222-194.5,220.6-197,220.6z M-127.8,184.5
			V181h-17.3v3.5h-38V181h-17.3v3.5h-24.2v-1.7c0-2.9-2.3-5.2-5.2-5.2c-2.9,0-5.2,2.3-5.2,5.2v91.7h10.4v-79.6h24.2v6.9h17.3v-6.9
			h38.1v6.9h17.3v-6.9h20.7v-10.4H-127.8z"/>
	</g>
</g>
<g id="Fence_1_" class="st0">
	<g id="icon_19_" class="st1">
		<g>
			<path class="st2" d="M-107,223.3v-10.9h-8.2v-10.9l-10.9-8.2l-10.9,8.2v10.9h-8.2v-10.9l-10.8-8.2l-10.9,8.2v10.9h-8.2v-10.9
				l-10.9-8.2l-10.9,8.2v10.9h-8.1v-10.9l-10.9-8.2l-10.9,8.2v10.9h-8.2v10.9h8.2v13.6h-8.2v10.9h8.2v10.9h21.8v-10.9h8.2v10.9h21.8
				v-10.9h8.2v10.9h21.8v-10.9h8v10.9h21.8v-10.9h8.2v-10.9h-8.2v-13.6H-107z M-221.4,245.1c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7
				s2.7,1.2,2.7,2.7S-219.9,245.1-221.4,245.1z M-221.4,220.6c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7
				C-218.7,219.3-219.9,220.6-221.4,220.6z M-210.5,245.1c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7
				S-209,245.1-210.5,245.1z M-210.5,220.6c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7
				C-207.8,219.3-209,220.6-210.5,220.6z M-196.9,236.9h-8.1v-13.6h8.2L-196.9,236.9L-196.9,236.9z M-191.4,245.1
				c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7S-189.9,245.1-191.4,245.1z M-191.4,220.6c-1.5,0-2.7-1.2-2.7-2.7
				s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7C-188.7,219.3-189.9,220.6-191.4,220.6z M-180.5,245.1c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7
				s2.7,1.2,2.7,2.7S-179,245.1-180.5,245.1z M-180.5,220.6c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7
				C-177.8,219.3-179,220.6-180.5,220.6z M-166.9,236.9h-8.2v-13.6h8.2V236.9z M-161.5,245.1c-1.5,0-2.7-1.2-2.7-2.7
				s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7S-160,245.1-161.5,245.1z M-161.5,220.6c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7
				s2.7,1.2,2.7,2.7C-158.7,219.3-160,220.6-161.5,220.6z M-150.6,245.1c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7
				S-149.1,245.1-150.6,245.1z M-150.6,220.6c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7
				C-147.9,219.3-149.1,220.6-150.6,220.6z M-137,236.9h-8.2v-13.6h8.2V236.9z M-131.5,245.1c-1.5,0-2.7-1.2-2.7-2.7
				s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7S-130,245.1-131.5,245.1z M-131.5,220.6c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7
				s2.7,1.2,2.7,2.7C-128.8,219.3-130,220.6-131.5,220.6z M-120.6,245.1c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7
				S-119.1,245.1-120.6,245.1z M-120.6,220.6c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7
				C-117.9,219.3-119.1,220.6-120.6,220.6z"/>
		</g>
	</g>
</g>
<g id="House_1_" class="st0">
	<g id="icon_20_" class="st1">
		<g>
			<path class="st2" d="M-148.9,214.4l-41.9-25.6l-44.2,25.6v4.6h86.1V214.4z M-146.9,216.9l0.3,4.4h-9.3l48.9,14v-7L-146.9,216.9z
				 M-225.7,263.2h23.3v-13.9h20.9v13.9h23.3v-41.8h-67.5V263.2z M-202.4,226h20.9v7h-9.3v-7h-2.4v7h-9.3v-7H-202.4z M-202.4,235.3
				h9.3v7h2.4v-7h9.3v7h-21V235.3z M-155.9,263.2h48.9v-25.6l-48.9-14V263.2z M-137.3,260.9h-7v-7h7V260.9z M-127.9,260.9h-7v-7h7
				V260.9z M-118.6,260.9h-7v-7h7V260.9z M-109.3,260.9h-7v-7h7V260.9z M-153.5,228.3l44.2,11.7v11.6h-44.2V228.3z M-153.5,253.9h7
				v7h-7V253.9z"/>
		</g>
	</g>
</g>
</svg>

  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPADealIcon {}

@Component({
  selector: 'app-maLo-icon',
  template: `
  <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
  width="24" height="24" viewBox="0 0 395.71 395.71"
  xml:space="preserve">
<g>
 <path d="M197.849,0C122.131,0,60.531,61.609,60.531,137.329c0,72.887,124.591,243.177,129.896,250.388l4.951,6.738
   c0.579,0.792,1.501,1.255,2.471,1.255c0.985,0,1.901-0.463,2.486-1.255l4.948-6.738c5.308-7.211,129.896-177.501,129.896-250.388
   C335.179,61.609,273.569,0,197.849,0z M197.849,88.138c27.13,0,49.191,22.062,49.191,49.191c0,27.115-22.062,49.191-49.191,49.191
   c-27.114,0-49.191-22.076-49.191-49.191C148.658,110.2,170.734,88.138,197.849,88.138z"/>
</g>
</svg>

  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPAMaLoIcon {}

@Component({
  selector: 'app-transaction-icon',
  template: `
  <svg class="svg-icon" width="24" height="24" style="vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M846.985936 163.175383 681.626817 163.175383l0 60.410881c0 1.095961-0.080841 2.162246-0.209778 3.231601L794.969235 226.817865c14.473643 0 26.177196 11.721973 26.177196 26.184359l0 551.60502c0 14.474666-11.714809 26.195615-26.177196 26.195615L226.97699 830.80286c-14.461363 0-26.184359-11.732206-26.184359-26.195615L200.792631 252.990968c0-14.458293 11.732206-26.184359 26.184359-26.184359L340.529185 226.806609c-0.127913-1.065262-0.215918-2.131547-0.215918-3.230578l0-60.400648L174.971545 163.175383c-14.458293 0-26.184359 11.733229-26.184359 26.184359L148.787186 868.257913c0 14.46341 11.725042 26.188452 26.184359 26.188452l672.01439 0c14.45113 0 26.176173-11.735275 26.176173-26.188452L873.162108 189.362812C873.158015 174.911682 861.437066 163.175383 846.985936 163.175383L846.985936 163.175383zM653.077597 226.594785c0 15.781428-15.003715 28.580942-33.587979 28.580942L401.629775 255.175727c-18.525935 0-33.559327-12.785188-33.559327-28.580942l0-71.491241c0-15.771195 15.033391-28.585035 33.559327-28.585035l217.844493 0c18.585287 0 33.589003 12.81384 33.589003 28.585035l0 71.491241L653.077597 226.594785 653.077597 226.594785zM272.427134 358.868367c0-11.231809 4.625344-22.396079 12.568247-30.340005 7.943926-7.943926 19.10615-12.568247 30.340005-12.568247 11.234879 0 22.399149 4.624321 30.338982 12.568247 7.944949 7.943926 12.568247 19.108197 12.568247 30.340005 0 11.233855-4.623297 22.398126-12.568247 30.342052-7.939833 7.939833-19.104103 12.564154-30.338982 12.564154-11.233855 0-22.396079-4.624321-30.340005-12.564154C277.051455 381.26547 272.427134 370.101199 272.427134 358.868367L272.427134 358.868367zM272.427134 532.772093c0-11.234879 4.625344-22.399149 12.568247-30.343075 7.943926-7.939833 19.10615-12.564154 30.340005-12.564154 11.234879 0 22.399149 4.624321 30.338982 12.564154 7.944949 7.943926 12.568247 19.108197 12.568247 30.343075 0 11.236925-4.623297 22.405289-12.568247 30.350239-7.939833 7.944949-19.104103 12.567223-30.338982 12.567223-11.233855 0-22.396079-4.623297-30.340005-12.567223C277.051455 555.176358 272.427134 544.009018 272.427134 532.772093L272.427134 532.772093zM272.427134 704.994526c0-11.234879 4.625344-22.396079 12.568247-30.337959 7.943926-7.944949 19.10615-12.567223 30.340005-12.567223 11.234879 0 22.399149 4.623297 30.338982 12.567223 7.944949 7.942903 12.568247 19.104103 12.568247 30.337959 0 11.233855-4.623297 22.399149-12.568247 30.340005-7.939833 7.942903-19.104103 12.567223-30.338982 12.567223-11.233855 0-22.396079-4.625344-30.340005-12.567223C277.051455 727.392652 272.427134 716.227358 272.427134 704.994526L272.427134 704.994526zM398.247748 328.46594l349.131609 0 0 47.846728-349.131609 0L398.247748 328.46594 398.247748 328.46594zM398.247748 508.826727l349.131609 0 0 47.868217-349.131609 0L398.247748 508.826727 398.247748 508.826727zM398.247748 681.07065l349.131609 0 0 47.846728-349.131609 0L398.247748 681.07065 398.247748 681.07065zM369.155153 681.07065"  /></svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPATransactionIcon {}

@Component({
  selector: 'app-generation-unit-icon',
  template: `
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
  width="26pt" height="24pt" viewBox="0 0 39.000000 41.000000"
  preserveAspectRatio="xMidYMid meet">
 <metadata>
 Created by potrace 1.10, written by Peter Selinger 2001-2011
 </metadata>
 <g transform="translate(0.000000,41.000000) scale(0.100000,-0.100000)"
 fill="#000000" stroke="none">
 <path d="M250 325 c-53 -43 -58 -44 -123 -45 -38 0 -66 -4 -63 -9 3 -4 33 -19
 66 -31 54 -20 63 -28 91 -76 48 -84 55 -73 32 49 -3 19 5 44 27 83 17 31 30
 60 28 65 -2 5 -28 -11 -58 -36z"/>
 <path d="M201 118 c-1 -34 -3 -37 -33 -40 -60 -6 -29 -23 47 -26 62 -2 75 0
 75 13 0 10 -9 15 -27 15 -23 0 -31 7 -45 38 l-16 37 -1 -37z"/>
 </g>
 </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PPAGenerationUnitIcon {}

@Component({
  selector: 'app-valuationtask-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValuationTaskIcon {}

@Component({
  selector: 'app-execute-valuationtask-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExecuteValuationTaskIcon {}

@Component({
  selector: 'app-model-result-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H6.911a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModelResultIcon {}

@Component({
  selector: 'app-aggregated-scenario-result-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AggregatedScenarioResultIcon {}

@Component({
  selector: 'app-valuationrun-results-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M7.875 14.25l1.214 1.942a2.25 2.25 0 001.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 011.872 1.002l.164.246a2.25 2.25 0 001.872 1.002h2.092a2.25 2.25 0 001.872-1.002l.164-.246A2.25 2.25 0 0116.954 9h4.636M2.41 9a2.25 2.25 0 00-.16.832V12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 01.382-.632l3.285-3.832a2.25 2.25 0 011.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0021.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 002.25 2.25z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValuationRunResultsIcon {}

@Component({
  selector: 'app-forwardcurve-revision-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForwardCurveRevisionIcon {}

@Component({
  selector: 'app-purge-analytical-sandbox-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSeriesAnalyticalSandboxDataPurgeIcon {}

@Component({
  selector: 'app-escalated-forwardcurve-reference-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062A1.125 1.125 0 013 16.81V8.688zM12.75 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062a1.125 1.125 0 01-1.683-.977V8.688z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EscalatedForwardCurveReferenceIcon {}

@Component({
  selector: 'app-escalated-forwardcurve-asofdate-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EscalatedForwardCurveAsOfDateIcon {}

@Component({
  selector: 'app-import-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 9.75v6.75m0 0l-3-3m3 3l3-3m-8.25 6a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportIcon {}

@Component({
  selector: 'app-check-circle-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckCircleIcon {}

@Component({
  selector: 'app-x-circle-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XCircleIcon {}

@Component({
  selector: 'app-circle-icon-processing',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircleIconProcessing {}

@Component({
  selector: 'app-shield-exclamation-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 9v3.75m0-10.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.249-8.25-3.286zm0 13.036h.008v.008H12v-.008z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShieldExclamationIcon {}

@Component({
  selector: 'app-calculator-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalculatorIcon {}

@Component({
  selector: 'app-table-cells-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0112 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellsIcon {}
